// react library imports
import { motion } from 'framer-motion';

// assets and style imports
import './Contact.css';

// imports from utils
import { headingAnimation, useAnimationHook } from 'Utils/animation';

const AcademyCard = ({children, btn, art, handleNavigation}) => {
  const {ref, mainControls}=useAnimationHook(0.5)
  return (
    <motion.div className="mues_academy_container mues_column_space_between"
    ref={ref} variants={headingAnimation} initial="hidden" animate={mainControls} style={{background:`url(${art})`, backgroundSize:'cover', backgroundRepeat:'no-repeat'}}>
      <div className='mues_academy_profile_container'>
        {children}
      </div>
      <div className='mues_row_center'>
          <button className='btn large_btn blue_btn' onClick={handleNavigation}>{btn}</button>
      </div>
    </motion.div>
  )
}

export default AcademyCard